import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./axiosInstance";

export const fetchCountries = createAsyncThunk(
    "checkout/fetchCountries",
    async (_,{ rejectWithValue }) => {
      try {
        const response = await axiosInstance.get("/countries");
        console.log('contries', response.data)
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response.data.errors || [error.response.data.error]
        );
      }
    }
  );
  export const fetchCities = createAsyncThunk(
    "checkout/fetchCities",
    async (_,{ rejectWithValue }) => {
      try {
        const response = await axiosInstance.get("/cities");
        console.log('Cities', response.data)
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response.data.errors || [error.response.data.error]
        );
      }
    }
  );
  export const createOrder = createAsyncThunk(
    "checkout/createOrder",
    async (data,{ rejectWithValue }) => {
      try {
        const response = await axiosInstance.post("/order/create", data);
        console.log('order create', response.data)
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response.data.errors || [error.response.data.error]
        );
      }
    }
  );